import {
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React from "react";
import moment from "moment";

const AssetsIssuedCard = ({ classes, employee }) => {
  return (
    <Paper className={classes.details_card}>
      <div className="details_head">
        <h5>Issued Assets</h5>
      </div>
      <div className="assets-table-wrapper" style={{ 
        '& table': { borderCollapse: 'collapse', borderSpacing: 0, padding: 0, margin: 0 }
      }}>
      <TableContainer 
        sx={{ 
          maxHeight: 440,
          '& table': {
            borderCollapse: 'collapse !important',
            borderSpacing: '0 !important',
            padding: '0 !important',
            margin: '0 !important',
          },
          '& .MuiTable-root': {
            borderCollapse: 'collapse !important',
            borderSpacing: '0 !important',
            padding: '0 !important',
            margin: '0 !important',
          }
        }}
      >
        <Table 
          size="medium" 
          sx={{ 
            width: '100%',
            tableLayout: 'fixed',
            borderCollapse: 'collapse !important',
            borderSpacing: '0 !important',
            padding: '0 !important',
            margin: '0 !important',
            '& .MuiTableCell-root': {
              padding: '16px !important',
              borderSpacing: '0 !important',
            },
            '& .MuiTableCell-head': {
              padding: '16px !important',
              borderBottom: '1px solid rgba(224, 224, 224, 1)',
            },
            '& .MuiTableCell-body': {
              padding: '16px !important',
            },
            '& .MuiTableRow-root': {
              borderBottom: '1px solid #e0e0e0 !important',
              borderTop: 'none !important',
              borderLeft: 'none !important',
              borderRight: 'none !important',
              '&:last-child': {
                borderBottom: 'none !important'
              }
            },
            '& .MuiTableCell-root': {
              borderLeft: 'none !important',
              borderRight: 'none !important',
              borderTop: 'none !important',
            },
          }}
        >
          <colgroup>
            <col style={{ width: '12%' }} />
            <col style={{ width: '15%' }} />
            <col style={{ width: '13%' }} />
            <col style={{ width: '13%' }} />
            <col style={{ width: '13%' }} />
            <col style={{ width: '13%' }} />
            <col style={{ width: '21%' }} />
          </colgroup>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 600, color: '#253766', padding: '16px !important' }}>Tag</TableCell>
              <TableCell sx={{ fontWeight: 600, color: '#253766', padding: '16px !important' }}>Category</TableCell>
              <TableCell sx={{ fontWeight: 600, color: '#253766', padding: '16px !important' }}>Brand</TableCell>
              <TableCell sx={{ fontWeight: 600, color: '#253766', padding: '16px !important' }}>Model</TableCell>
              <TableCell sx={{ fontWeight: 600, color: '#253766', padding: '16px !important' }}>Condition</TableCell>
              <TableCell sx={{ fontWeight: 600, color: '#253766', padding: '16px !important' }}>Status</TableCell>
              <TableCell sx={{ fontWeight: 600, color: '#253766', padding: '16px !important' }}>Issue Date</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {employee?.assets_issued && employee.assets_issued.length > 0 ? (
              employee.assets_issued.map((asset) => (
                <TableRow 
                  key={asset._id}
                  sx={{
                    borderBottom: '1px solid #e0e0e0 !important',
                    borderTop: 'none !important',
                    borderLeft: 'none !important',
                    borderRight: 'none !important',
                    '&:last-child': {
                      borderBottom: 'none !important'
                    },
                    '& .MuiTableCell-root': {
                      borderLeft: 'none !important',
                      borderRight: 'none !important',
                      borderTop: 'none !important',
                      borderBottom: 'none !important',
                    }
                  }}
                >
                  <TableCell sx={{ padding: '16px !important' }}>{asset.tag || '-'}</TableCell>
                  <TableCell sx={{ padding: '16px !important' }}>
                    {asset.category?.name
                      ? asset.category.name.charAt(0).toUpperCase() + asset.category.name.slice(1)
                      : '-'}
                  </TableCell>
                  <TableCell sx={{ padding: '16px !important' }}>{asset.brand || '-'}</TableCell>
                  <TableCell sx={{ padding: '16px !important' }}>{asset.model || '-'}</TableCell>
                  <TableCell sx={{ padding: '16px !important' }}>
                    {asset.condition
                      ? asset.condition.charAt(0).toUpperCase() + asset.condition.slice(1)
                      : '-'}
                  </TableCell>
                  <TableCell sx={{ padding: '16px !important' }}>
                    {asset.availibility_status
                      ? asset.availibility_status
                          .split(' ')
                          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                          .join(' ')
                      : '-'}
                  </TableCell>
                  <TableCell sx={{ padding: '16px !important' }}>
                    {asset.issue_date
                      ? moment(asset.issue_date).format("DD-MM-YYYY")
                      : '-'}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={7} align="center" sx={{ padding: '16px !important' }}>
                  <Typography style={{ color: '#666' }}>
                    No assets issued
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      </div>
      <style>{`
        .assets-table-wrapper table {
          border-collapse: collapse !important;
          border-spacing: 0 !important;
          padding: 0 !important;
          margin: 0 !important;
        }
        .assets-table-wrapper .MuiTable-root {
          border-collapse: collapse !important;
          border-spacing: 0 !important;
          padding: 0 !important;
          margin: 0 !important;
        }
        .assets-table-wrapper .MuiTableCell-root {
          padding: 16px !important;
          border-left: none !important;
          border-right: none !important;
          border-top: none !important;
        }
        .assets-table-wrapper .MuiTableRow-root {
          border-bottom: 1px solid #e0e0e0 !important;
          border-top: none !important;
          border-left: none !important;
          border-right: none !important;
        }
        .assets-table-wrapper .MuiTableRow-root:last-child {
          border-bottom: none !important;
        }
        .assets-table-wrapper table > tbody > tr > td {
          border: none !important;
          border-bottom: 1px solid #e0e0e0 !important;
          border-top: none !important;
          border-left: none !important;
          border-right: none !important;
        }
        .assets-table-wrapper table > tbody > tr:last-child > td {
          border-bottom: none !important;
        }
        .assets-table-wrapper table > tbody > tr:nth-child(odd) > td,
        .assets-table-wrapper table > tbody > tr:nth-child(even) > td {
          border-top: none !important;
          border-bottom: 1px solid #e0e0e0 !important;
          border-left: none !important;
          border-right: none !important;
        }
        .assets-table-wrapper table > tbody > tr:nth-child(odd) > td:first-child,
        .assets-table-wrapper table > tbody > tr:nth-child(even) > td:first-child {
          border-left: none !important;
        }
        .assets-table-wrapper table > tbody > tr:nth-child(odd) > td:last-child,
        .assets-table-wrapper table > tbody > tr:nth-child(even) > td:last-child {
          border-right: none !important;
        }
      `}</style>
    </Paper>
  );
};

export default AssetsIssuedCard;